import { useSiteConfig } from "@/hooks/useSiteConfig";
import { Reveal, SectionHeader, StatusChip } from "./primitives";

const Governance = () => {
  const config = useSiteConfig();
  return (
    <section id="governance" className="relative py-24 lg:py-36 border-t border-line" data-testid="governance-section">
      <div className="section-shell">
        <SectionHeader
          index={10}
          eyebrow="Governance"
          title={<>A Deliberate Path<br />to Decentralization</>}
          sub="Governance transitions in three stages — from foundation stewardship to full community control."
          testId="governance-header"
        />
        <div className="mt-14 grid gap-5 lg:grid-cols-3">
          {config.governanceStages.map((s, i) => {
            const isDao = i === 2;
            return (
              <Reveal key={s.stage} delay={i * 0.12} testId={`governance-stage-${i + 1}`}>
                <article className={`card-surface relative h-full rounded-xl p-8 ${isDao ? "border-gold/40" : ""}`}>
                  {i < 2 && (
                    <div className="hidden lg:block absolute top-1/2 -right-[22px] z-10 text-teal font-mono" aria-hidden="true">→</div>
                  )}
                  <div className="flex items-center justify-between gap-3">
                    <span className={`font-mono text-xs tracking-[0.3em] ${isDao ? "text-gold" : "text-teal"}`}>{s.stage}</span>
                    <StatusChip tone={isDao ? "gold" : i === 0 ? "teal" : "slate"} testId={`governance-status-${i + 1}`}>
                      {s.status}
                    </StatusChip>
                  </div>
                  <h3 className="mt-5 font-display text-xl lg:text-2xl font-semibold text-mist uppercase tracking-wide">{s.title}</h3>
                  <p className="mt-3 text-xs text-slate leading-relaxed">
                    {i === 0 && "Foundation responsibilities include:"}
                    {i === 1 && "JCV holders begin participating through formal proposals. Potential areas:"}
                    {i === 2 && "Governance authority progressively transitions to a decentralized autonomous organization. Potential responsibilities:"}
                  </p>
                  <ul className="mt-4 space-y-2.5">
                    {s.items.map((item) => (
                      <li key={item} className="flex items-start gap-3 text-sm text-slate">
                        <span className={`mt-[7px] h-1.5 w-1.5 rounded-full shrink-0 ${isDao ? "bg-gold" : "bg-teal"}`} aria-hidden="true" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Governance;
